import { MenuList as MenuListCore, Transition } from '@studiometa/ui';

/**
 * MenuListMenuList
 */
export default class MenuList extends MenuListCore {
  static config = {
    ...MenuListCore.config,
    components: {
      MenuList,
      Transition,
    },
  };

  /**
   *
   */
  onItemsOpen() {
    this.$children.Transition.forEach((transition) => transition.enter());
  }

  /**
   *
   */
  onItemsClose() {
    this.$children.Transition.forEach((transition) => transition.leave());
  }
}
